import HotelPlanTooltip from 'components/ReusableComponents/HotelPlanTooltip'
import { useHotelPlanInfo } from 'features/Hotel/useHotelPlanInfo'

const HotelPurchasedPlan = () => {
  const { solutionFeatures, shouldShow } = useHotelPlanInfo()

  if (!shouldShow) {
    return null
  }

  return (
    <HotelPlanTooltip solutionFeatures={solutionFeatures} iconOnly iconSize={22} align="right" />
  )
}

export default HotelPurchasedPlan
